import { Badge, cn } from '@seen/ui'
import type { JSX } from 'react'
import type { ConditionPickerCondition } from '#src/components/condition-picker/types.ts'

const SECTION_BADGE: Record<
  ConditionPickerCondition['section'],
  { label: string; dotClassName?: string }
> = {
  active: { label: 'Active', dotClassName: 'bg-emerald-500' },
  inactive: { label: 'Inactive', dotClassName: 'bg-zinc-400' },
  organization: { label: 'New' },
  icd10: { label: 'New' },
}

export function ConditionSectionBadge({
  condition,
}: {
  condition: ConditionPickerCondition
}): JSX.Element {
  const badge = SECTION_BADGE[condition.section]
  const isControlled =
    condition.section === 'active' && condition.clinicalStatus === 'controlled'
  const label = isControlled ? 'Controlled' : badge.label
  const dotClassName = isControlled ? 'bg-amber-500' : badge.dotClassName

  return (
    <Badge className="shrink-0 font-normal" size="xs" variant="outline">
      {dotClassName && (
        <span aria-hidden className={cn('size-1 rounded-full', dotClassName)} />
      )}
      {label}
    </Badge>
  )
}
